<template>
  <div class="surveillance-biology">
    <el-table
      :data="biologyInfo">
      <el-table-column
        width="130">
        <template scope="scope">
          {{ scope.row.label }}
        </template>
      </el-table-column>
      <el-table-column
        prop="date"
        label="Organism"
        width="200">
        <template scope="scope">
          <el-select placeholder="Not Selected">
            <el-option
              v-for="item in organisms"
              :label="item.name"
              :value="item.id">
            <span style="float: left">{{ item.name }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="Antibiotic Sensitivity">
        <template scope="scope"
        width="200">
          <el-select placeholder="Not Selected">
        </template>
      </el-table-column>
      <el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'surveillance-biology',
  props: ['organisms'],
  data: function () {
    return {
      biologyInfo: [
        {
          label: 'Primary'
        },
        {
          label: 'Secondary'
        },
        {
          label: 'Primary'
        },
        {
          label: 'Quaternary'
        }
      ]
    }
  }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// SurveillanceBiology.vue?5153321e